import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('khadam_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  sendVerification: (data) => api.post('/auth/send-verification', data),
  verifyCode: (data) => api.post('/auth/verify-code', data),
};

// Categories & Cities
export const categoriesAPI = {
  getAll: () => api.get('/categories'),
};

export const citiesAPI = {
  getAll: () => api.get('/cities'),
};

// Providers
export const providersAPI = {
  getAll: (params) => api.get('/providers', { params }),
  getById: (id) => api.get(`/providers/${id}`),
  register: (data) => api.post('/providers/register', data),
  prepay: (id, data) => api.put(`/providers/${id}/prepay`, data),
  getDashboard: () => api.get('/providers/me/dashboard'),
};

// Bookings
export const bookingsAPI = {
  create: (data) => api.post('/bookings', data),
  getById: (id) => api.get(`/bookings/${id}`),
};

// Reviews
export const reviewsAPI = {
  getLatest: () => api.get('/reviews/latest'),
  getByProvider: (providerId) => api.get('/reviews', { params: { provider_id: providerId } }),
  create: (data) => api.post('/reviews', data),
};

// Stats
export const statsAPI = {
  get: () => api.get('/stats'),
};

export default api;
